import React, { useState, useEffect } from 'react'
import styles from "./styles.module.css";
import { connect } from 'react-redux';
import Loader from 'react-loader'

import { getUniversity } from '../../../actions/report';

import BtnBack from '../helper/btnBackMTO/BtnBack';
import GetHeader from '../helper/getHeader/GetHeader';

import bg from '../../../assets/dashboard/background_1.png'
import logo_big from '../../../assets/dashboard/logo_big.png'
import { BACKEND_URL_PREFIX } from '../../../utils/const';
import { store } from '../../App';
import { signOut } from '../../../actions/auth';
import { DASH_PPS } from '../../../utils/hardcode'


const mainPPSList = [
  { label: 'военнослужащие', value: 'military' },
  { label: 'профессоров', value: 'professor' },
  { label: 'гражданский персонал', value: 'citizen' },
  { label: 'доцентов', value: 'docent' },
  { label: 'докторов наук', value: 'doctor' },
  { label: 'укомплектованность ппс учеными', value: 'staffing_scientists' },
  { label: 'кандидатов наук', value: 'candidate' }
]


// const docAdStaffList = [
//   { label: 'докторантура', value: 'doctor' },
//   { label: 'очная адъюнктура', value: 'fulltime_adjuncture' },
// ]

const docAdStaffList = [
  { label: 'докторантура', value: 'doctor' },
  { label: 'очная адъюнктура', value: 'fulltime_adjuncture' },
  { label: 'слушатели', value: 'listeners' }, //сам назвал
  { label: 'курсанты', value: 'cadets' },//сам назвал
]
const staffListArr = [
  {
    "doctor": 100,
    "fulltime_adjuncture": 100,
    'listeners': 100,
    'cadets': 100,
  }
]

// const avgGiaMarkList = [
//   { label: 'Государственный междисциплинарный экзамен', value: 'gos_interdisc_exam' },
//   { label: 'Защита ВКР', value: 'vkr' },
//   { label: 'Государственный экзамен по физической подготовке', value: 'gos_fiz' }
// ]

const monthList = [
  { en: 'sep', ru: 'сен', num: 9 },
  { en: 'oct', ru: 'окт', num: 10 },
  { en: 'nov', ru: 'нов', num: 11 },
  { en: 'decb', ru: 'дек', num: 12 },
  { en: 'jan', ru: 'янв', num: 1 },
  { en: 'feb', ru: 'фев', num: 2 },
  { en: 'mar', ru: 'мар', num: 3 },
  { en: 'apr', ru: 'апр', num: 4 },
  { en: 'may', ru: 'май', num: 5 },
  { en: 'jun', ru: 'июн', num: 6 },
  { en: 'jul', ru: 'июл', num: 7 },
  { en: 'aug', ru: 'авг', num: 8 }
]
const avgGiaMarkList =
  [
    {
      "avg_grade": 3.2,
      "typeid": 97,
      "typename": "Итоговая гос.аттестация.Гос.экзамен по специальности"
    },
    {
      "avg_grade": 4,
      "typeid": 98,
      "typename": "Государственный экзамен по физической подготовке"
    },
    {
      "avg_grade": 3.7,
      "typeid": 99,
      "typename": "Итоговая гос.аттестация.Защита выпускной квалификационной работы"
    }
  ]

const ipRegex = /\b(?:\d{1,3}\.){3}\d{1,3}\b/;


function PersonalMain({
  university,
  getUniversity,
  match,
  ...props
}) {

  const [uni, setUni] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { id } = match.params
  const dispatch = store.dispatch;
  const history = props?.history
  const { main_pps_stat, doc_ad_staffing, mark_stat, avg_gia_mark } = data || {}

  useEffect(() => {
    setLoading(true)
    university && university.length > 0 && id != 'all' && getUniversity();
  }, []);

  useEffect(() => {
    if (university && university.length > 0 && id != null && id != 'all') {
      const [one, two] = id.split('_');
      const univer = two ? university[one].branches[two] : university[one]
      const prefix = univer?.api_url
      if (prefix?.length > 1) {
        const url = `${prefix}dashboard/university_stat`
        fetch(url)
          .then(resp => resp.json())
          .then(data => setResponseData(data))
      }
      setUni(univer)
    }
    if (id == 'all' && university && university.length > 0) {
      const url = `${BACKEND_URL_PREFIX}/dashboard/university_stat`
      fetch(url)
        .then(resp => resp.json())
        .then(data => setResponseData(data))
    }
  }, [university]);

  const setResponseData = (data) => {
    setData(data)
    setLoading(false)
  }

  const renderMainPPSStat = () => {

    const url = university.map(el => el.api_url.length > 1 && (el.api_url).match(ipRegex)[0])[id]

    const main_pps_stat = DASH_PPS[url]

    const firstULlist = mainPPSList.filter((_, ind) => ind % 2 === 0)
    const secondULlist = mainPPSList.filter((_, ind) => ind % 2 === 1)

    const renderLi = ({ label, value }) => (
      <li>
        <span>{main_pps_stat[value]}%</span>
        {label}
      </li>
    )

    return (
      <div className={styles.firstMain}>
        <ul>{firstULlist.map(renderLi)}</ul>
        <ul>{secondULlist.map(renderLi)}</ul>
      </div>
    )
  }
  //renderStatStaff///////////////////////////////////////////////////////////////////////////////////////////////////

  // академия 192.168.199.201 == 
  // омск 193.200.200.100 == 
  // вольск 198.100.100.100 ==
  // пенза 10.79.200.80
  // ждв 193.100.100.100 == 
  // ии 193.167.10.18 == 
  const renderStatStaff = () => {
    let staff
    const ipRegex = /\b(?:\d{1,3}\.){3}\d{1,3}\b/;
    const url = university.map(el => el.api_url.length > 1 && (el.api_url).match(ipRegex)[0])[id]

    switch (url) {
      // пример
      case "10.120.7.20": staff =
      {
        "doctor": 10,
        "fulltime_adjuncture": 33,
        'listeners': 41,
        'cadets': 91,
      };
        break;

      // академия 192.168.199.201
      case '192.168.199.201': staff = {
        "doctor": 100,
        "fulltime_adjuncture": 97,
        'listeners': 99,
        'cadets': 77,
      };
        break;
      // ии 193.167.10.18
      case '193.167.10.18': staff = {
        "doctor": 0,
        "fulltime_adjuncture": 0,
        'listeners': 0,
        'cadets': 92
      };
        break;

      // ждв 193.100.100.100 // 
      case '193.167.10.18': staff = {
        "doctor": 0,
        "fulltime_adjuncture": 0,
        'listeners': 0,
        'cadets': 94,
      };
        break;
      // вольск 198.100.100.100
      case '198.100.100.100': staff = {
        "doctor": 100,
        "fulltime_adjuncture": 100,
        'listeners': 0,
        'cadets': 75,
      };
        break;
      // омск 193.200.200.100
      case '193.200.200.100': staff = {
        "doctor": 100,
        "fulltime_adjuncture": 100,
        'listeners': 0,
        'cadets': 85,
      };
        break;
      // пенза 10.79.200.80
      case '10.79.200.80': staff = {
        "doctor": 100,
        "fulltime_adjuncture": 100,
        'listeners': 0,
        'cadets': 94,
      };
        break;

      default: staff = ''
        break;
    }
    return staff
  }
  // ///////////////////////////////////////////////////////////////////////////////////////////////////

  const renderDocAdStaff = () => {
    const staff = renderStatStaff()
    const renderLi = ({ label, value }) => (
      <li>
        <span>{staff[value]}%</span>
        {label}
      </li>
    )

    return <ul>{docAdStaffList.map(renderLi)}</ul>
  }

  const getRusMonth = (month) => {
    return monthList.find(el => el.en == month.en)
  }
  const getRusMonth2 = (month) => {
    return monthList.find(el => el.num == month.value.month)
  }

  useEffect(() => {
    const someValue = store.getState().auth.access_modes?.['Режимы']?.['Показатели деятельности вуза']
    if (someValue != 'Полный' && id == 'all') {
      dispatch(signOut(history))
    }
  }, []);

  const renderMarkStat = () => {
    const ruMass = []
    Object.keys(mark_stat).forEach(function (key, index) {
      ruMass.push({ value: mark_stat[key], en: key });
    });
    return (
      <div className={styles.progressBlock}>
        <div className={styles.lineBLock}>
          {[2, 2.5, 3, 3.5, 4, 4.5, 5].map(el =>
            <div className={styles.lineItem}>{el} <div className={styles.lineItemInner}></div></div>)}
        </div>
        {ruMass?.map((el) =>
          <div className={styles.progress}>
            <div className={styles.score} style={{ height: `${(300 / 14) + (el.value.grade - 2) * (300 / 3.5)}px` }}><span></span></div>
            {/* <div className={styles.month}>{getRusMonth(el)?.ru}</div> */}
            <div className={styles.month}>{getRusMonth2(el)?.ru}</div>
          </div>
        )
        }
      </div>
    )
  }

  // академия 192.168.199.201 == 
  // омск 193.200.200.100 == 
  // вольск 198.100.100.100 ==
  // пенза 10.79.200.80
  // ждв 193.100.100.100 == 
  // ии 193.167.10.18 == 

  const renderMark = () => {
    let mark
    const ipRegex = /\b(?:\d{1,3}\.){3}\d{1,3}\b/;
    const url = university.map(el => el.api_url.length > 1 && (el.api_url).match(ipRegex)[0])[id]

    switch (url) {
      // пример
      // case "10.120.7.20": mark = [
      //   {
      //     "avg_grade": 4.1,
      //     "typeid": 97,
      //     "typename": "Итоговая гос.аттестация.Гос.экзамен по специальности"
      //   },
      //   {
      //     "avg_grade": 4.7,
      //     "typeid": 98,
      //     "typename": "Государственный экзамен по физической подготовке"
      //   },
      //   {
      //     "avg_grade": 4.8,
      //     "typeid": 99,
      //     "typename": "Итоговая гос.аттестация.Защита выпускной квалификационной работы"
      //   }
      // ];
      //   break;

      // академия 192.168.199.201
      case '192.168.199.201': mark = [
        {
          "avg_grade": 4.41,
          "typeid": 97,
          "typename": "Итоговая гос.аттестация.Гос.экзамен по специальности"
        },
        {
          "avg_grade": 4.80,
          "typeid": 98,
          "typename": "Государственный экзамен по физической подготовке"
        },
        {
          "avg_grade": 4.40,
          "typeid": 99,
          "typename": "Итоговая гос.аттестация.Защита выпускной квалификационной работы"
        }
      ];
        break;
      // ии 193.167.10.18
      case '193.167.10.18': mark = [
        {
          "avg_grade": 4.47,
          "typeid": 97,
          "typename": "Итоговая гос.аттестация.Гос.экзамен по специальности"
        },
        {
          "avg_grade": 4.89,
          "typeid": 98,
          "typename": "Государственный экзамен по физической подготовке"
        },
        {
          "avg_grade": 4.45,
          "typeid": 99,
          "typename": "Итоговая гос.аттестация.Защита выпускной квалификационной работы"
        }
      ];
        break;

      // ждв 193.100.100.100
      case '193.167.10.18': mark = [
        {
          "avg_grade": 4.30,
          "typeid": 97,
          "typename": "Итоговая гос.аттестация.Гос.экзамен по специальности"
        },
        {
          "avg_grade": 4.77,
          "typeid": 98,
          "typename": "Государственный экзамен по физической подготовке"
        },
        {
          "avg_grade": 4.08,
          "typeid": 99,
          "typename": "Итоговая гос.аттестация.Защита выпускной квалификационной работы"
        }
      ];
        break;
      // вольск 198.100.100.100
      case '198.100.100.100': mark = [
        {
          "avg_grade": 4.03,
          "typeid": 97,
          "typename": "Итоговая гос.аттестация.Гос.экзамен по специальности"
        },
        {
          "avg_grade": 4.65,
          "typeid": 98,
          "typename": "Государственный экзамен по физической подготовке"
        },
        {
          "avg_grade": 4.18,
          "typeid": 99,
          "typename": "Итоговая гос.аттестация.Защита выпускной квалификационной работы"
        }
      ];
        break;
      // омск 193.200.200.100
      case '193.200.200.100': mark = [
        {
          "avg_grade": 4.44,
          "typeid": 97,
          "typename": "Итоговая гос.аттестация.Гос.экзамен по специальности"
        },
        {
          "avg_grade": 4.81,
          "typeid": 98,
          "typename": "Государственный экзамен по физической подготовке"
        },
        {
          "avg_grade": 4.51,
          "typeid": 99,
          "typename": "Итоговая гос.аттестация.Защита выпускной квалификационной работы"
        }
      ];
        break;
      // пенза 10.79.200.80
      case '10.79.200.80': mark = [
        {
          "avg_grade": 4.64,
          "typeid": 97,
          "typename": "Итоговая гос.аттестация.Гос.экзамен по специальности"
        },
        {
          "avg_grade": 4.90,
          "typeid": 98,
          "typename": "Государственный экзамен по физической подготовке"
        },
        {
          "avg_grade": 4.71,
          "typeid": 99,
          "typename": "Итоговая гос.аттестация.Защита выпускной квалификационной работы"
        }
      ];
        break;

      default: mark = ''
        break;
    }
    return mark
  }

  // renderMark()

  const renderAvgGiaMark = () => {
    // const goodList = avgGiaMarkList.map(({ value }) => ({ key: value, value: avg_gia_mark[value] }))
    const mark = renderMark()

    return (
      <div className={styles.avg_mark}>
        {mark &&
          <div className={styles.blocks}>
            <div className={styles.avg_markChartCylinderContainer}>
              {mark?.map((el, inx) => {
                const height = `${130 / mark?.map(el => el.avg_grade).sort((a, b) => b - a)[0] * el.avg_grade}px`

                return (
                  <div className={styles[`honors_degreeBlock_${inx}`]}>
                    <div className={styles.chartCylinder} style={{ height: height }}>
                      <div className={styles.perc}>{el.avg_grade}</div>
                    </div>
                    <span style={{ height: '80px' }}>{el.typename}</span>
                  </div>

                )
              })}
            </div>
          </div>
        }
      </div>
    )
  }

  return (
    <div className={styles.wrapper}>
      <img src={bg} className={styles.bg} />
      <div className={styles.logo_bigWrapper}>
        <img src={logo_big} className={styles.logo_big} />
      </div>
      <GetHeader title={<>ПОКАЗАТЕЛИ ДЕЯТЕЛЬНОСТИ {uni?.name}</>} pathLogo={uni?.api_url} />
      <Loader loaded={!loading} color="grey">

        {
          data &&
          <div className={styles.wrapperBlock}>

            <div className={styles.first}>
              <h4 className={styles.title}>КАЧЕСТВЕННАЯ ХАРАКТЕРИСТИКА ППС</h4>
              {renderMainPPSStat()}
            </div>

            <div className={styles.second}>
              <h4 className={styles.title}>УКОМПЛЕКТОВАННОСТЬ</h4>
              {renderDocAdStaff()}
            </div>

            <div className={styles.third}>
              <h4 className={styles.title}>ДИНАМИКА УСПЕВАЕМОСТИ ЗА ТЕКУЩИЙ УЧЕБНЫЙ ГОД (СРЕДНИЙ БАЛЛ)</h4>
              {renderMarkStat()}
            </div>

            <div className={styles.fourth}>
              <h4 className={styles.title}>СРЕДНИЙ БАЛЛ СДАЧИ ГОСУДАРСТВЕННЫХ АТТЕСТАЦИОННЫХ ИСПЫТАНИЙ ЗА УЧЕБНЫЙ ГОД</h4>
              {renderAvgGiaMark()}
            </div>

          </div>
        }

      </Loader>
      <BtnBack />
    </div>
  )
}

const mapStateToProps = ({ report: { university } }) => ({ university });

export default connect(mapStateToProps, { getUniversity })(PersonalMain);